import { motion } from "framer-motion";

/**
 * Official Plus Belle la Vie 971 logo.
 * variant "dark" wraps the logo on a light chip so it stays legible on dark backgrounds.
 */
export const Logo = ({ className = "", dark = false }) => {
  return (
    <a
      href="#top"
      data-testid="logo-link"
      aria-label="Plus Belle la Vie 971 — Accueil"
      className={`group inline-flex items-center ${className}`}
    >
      <motion.span
        whileHover={{ scale: 1.03 }}
        transition={{ type: "spring", stiffness: 260, damping: 18 }}
        className={
          dark
            ? "inline-flex rounded-2xl bg-white/95 p-2.5 shadow-sm"
            : "inline-flex"
        }
      >
        <img
          src="/logo-tpoz.jpg"
          alt="T'POZ — Répit • Ressourcement — un réseau porté par Plus Belle La Vie 971"
          className={dark ? "h-14 w-auto object-contain" : "h-14 w-auto object-contain md:h-16"}
          loading="eager"
        />
      </motion.span>
    </a>
  );
};

export default Logo;
